/* tslint:disable */
/* eslint-disable */
/**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    RuntimeStatsInfo,
    RuntimeStatsInfoFromJSON,
    RuntimeStatsInfoFromJSONTyped,
    RuntimeStatsInfoToJSON,
} from './';

/**
 * 
 * @export
 * @interface RuntimeStatsResponse
 */
export interface RuntimeStatsResponse {
    /**
     * 
     * @type {number}
     * @memberof RuntimeStatsResponse
     */
    online: number;
    /**
     * 
     * @type {number}
     * @memberof RuntimeStatsResponse
     */
    offline: number;
    /**
     * 
     * @type {Array<RuntimeStatsInfo>}
     * @memberof RuntimeStatsResponse
     */
    list: Array<RuntimeStatsInfo>;
}

export function RuntimeStatsResponseFromJSON(json: any): RuntimeStatsResponse {
    return RuntimeStatsResponseFromJSONTyped(json, false);
}

export function RuntimeStatsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RuntimeStatsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'online': json['online'],
        'offline': json['offline'],
        'list': ((json['list'] as Array<any>).map(RuntimeStatsInfoFromJSON)),
    };
}

export function RuntimeStatsResponseToJSON(value?: RuntimeStatsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'online': value.online,
        'offline': value.offline,
        'list': ((value.list as Array<any>).map(RuntimeStatsInfoToJSON)),
    };
}


